function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bx-support",
  transform: "translate(0.624 1.624)"
}, /*#__PURE__*/React.createElement("path", {
  id: "bx-support-2",
  "data-name": "bx-support",
  d: "M24,3A21.021,21.021,0,0,0,3,24v8.7a4.061,4.061,0,0,0,4.2,3.9H9.3a2.1,2.1,0,0,0,2.1-2.1V23.7a2.1,2.1,0,0,0-2.1-2.1H7.393a16.773,16.773,0,0,1,33.209,0H38.7a2.1,2.1,0,0,0-2.1,2.1V36.6a4.2,4.2,0,0,1-4.2,4.2H28.2V38.7H19.8v6.3H32.4a8.407,8.407,0,0,0,8.4-8.4,4.061,4.061,0,0,0,4.2-3.9V24A21.021,21.021,0,0,0,24,3Z",
  transform: "translate(-3 -3)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_259",
  "data-name": "Line 259",
  y1: 37,
  x2: 37,
  transform: "translate(1.497 0.497)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_260",
  "data-name": "Line 260",
  y1: 37,
  x2: 37,
  transform: "translate(3.497 2.497)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeWidth: 3
}));

var SvgBxSupport = function SvgBxSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.243,
    height: 43.618,
    viewBox: "0 0 43.243 43.618",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bx-support.3d47415a.svg";
export { ForwardRef as ReactComponent };